import styled, { css } from 'styled-components';
import { colors } from '../theme';

const mapRoleToBackground = {
  success: 'green',
  primary: 'purple',
  primary2: 'purple2',
  info: 'tertiary',
  error: 'red',
  light: 'carbon',
  black: 'primary',
};

export type BackgroundType = {
  backgroundImage?: string;
  backgroundRole?: 'success' | 'primary' | 'info' | 'error' | 'light';
};
export const mapRoleToBackgroundColor = (type) =>
  colors[mapRoleToBackground[type]] || 'transparent';

export const BackgroundStyle = css`
  background-color: ${({ backgroundRole }: any) =>
    mapRoleToBackgroundColor(backgroundRole)};

  background-image: url(${({ backgroundImage }: any) => backgroundImage});
  background-repeat: no-repeat;
`;
